import {
    groqStringGlobal,
    groqStringContentAdmin,
    groqStringContentProducts,
} from './groqStrings'
const flatten = require('flat')
// client uses cdn
// clientForPreview does not use cdn
import { client, clientForPreview } from '~/plugins/global.js'
// convert an array of strings to a string for interpolation
function arrayToString(array) {
    let string = ''
    if (typeof array === 'object' && array.length > 0) {
        string = array.join('","')
    }
    return '["' + string + '"]'
}

// logic to assemble the page-specific groq query string
function buildGroqString({
    query = {}, // the query params, if exists
    slug = '', // typically passed params.slug
    type = 'page', // sanity _type of document (page, product, category, etc)
}) {
    // default projection
    // let projection = groqString
    const typeArrayAsString =
        typeof type === 'string' ? '["' + type + '"]' : arrayToString(type)
    // PREVIEWS
    // if this is a preview for a published document
    let filter = ''
    if (query.preview) {
        // if this is a preview for a published document
        filter = `(_id == "${query.preview}")`
        if (query.preview.indexOf('drafts') === 0) {
            // if this is a preview for a drafted document
            filter = `(_id in path("${query.preview}"))`
        } else if (query.preview.indexOf('please-set-valid-slugs') === 0) {
            // if this is a preview with invalid slug, load drafts page
            filter = `(_type == "page" && slug.en.current == "drafts")`
        }
    }
    // CURRENT SINGLE DOCUMENT (page, category, product, etc)
    if (!query.preview) {
        filter = `(_type in ${typeArrayAsString} && (slug.es.current == "${slug}" || slug.en.current == "${slug}" || slug.current == "${slug}"))`
    }
    // (extra projection appended depending on the following types :)
    let projection = groqStringGlobal
    // CONTENT ADMIN DASHBOARD
    if (type === 'page' && ['content'].includes(slug)) {
        groqStringContentAdmin || console.log('NO GROQ STRING NERF')
        // projection += ``
        projection += `,${groqStringContentAdmin}`
    } else if (type === 'page' && ['productadmin'].includes(slug)) {
        projection += `,${groqStringContentProducts}`
    }

    const groq = `*[${filter}][0]{${projection}}`
    // console.log('groq', groq)
    return groq
}

async function getOrignalFileName(refList, sanityClient) {
    return await sanityClient.fetch(
        `*[_id in ${JSON.stringify(refList)}]{_id,originalFilename}`
    )
}

export async function processImages(content, sanityClient = client) {
    try {
        const flattenObj = flatten(content)
        const refList = Object.entries(flattenObj)
            .filter(([key]) => key.includes('asset._ref'))
            .map((i) => i[1])
        const filenameList = await getOrignalFileName(refList, sanityClient)
        const newProps = Object.entries(flattenObj)
            .filter(([key]) => key.includes('asset._ref'))
            .map(([key, value]) => {
                const prefixPath = key.split('.')
                prefixPath[prefixPath.length - 1] = 'originalFilename'
                const imgObj = filenameList.find((i) => i._id == value)
                return [prefixPath.join('.'), imgObj.originalFilename]
            })
        for (const [key, value] of newProps) {
            // console.log([key, value])
            flattenObj[key] = value
        }
        return flatten.unflatten(flattenObj)
    } catch (error) {
        console.log(content.slug.en)
        console.log('****************')
        console.log(error)
    }
}

export default async function ({
    params = null,
    error = [],
    payload = null,
    store = null,
    query = {},
    type = null,
    lang = 'en',
}) {
    // console.log('params are', params)
    const groq = buildGroqString({ query, slug: params.slug, type })
    const sanityClient = query.preview ? clientForPreview : client
    // trim the whitespace from groq... feels silly to call function because vs code prettier config?
    const content = await sanityClient
        .fetch(groq.trim(), {
            params,
        })
        .then((res) => {
            // console.log('content =', res)
            // query will always return res, but if no matching documents were found in sanity
            // res will be empty object {}
            return res
        })
        .catch((err) => {
            // console.log('ERROR NAME:', err.name)
            // console.log('ERROR MESSAGE:', err.message)
            // console.log('ERROR STACK:', err.stack)
            return err
        })

    const newContent = await processImages(content, sanityClient)
    // IMPORTANT! Nerfing Spanish temporarily 6/4/2020 DJH
    // if (!query.preview) {
    //     await store.dispatch('i18n/setRouteParams', {
    //         en: {
    //             slug:
    //                 content.slug && content.slug.en
    //                     ? content.slug.en.current
    //                     : params.slug
    //         }
    //
    //         // es: {
    //         //     slug:
    //         //         content.slug && content.slug.es
    //         //             ? content.slug.es.current
    //         //             : params.slug
    //         // }
    //     })
    // }

    return {
        content: newContent,
        error,
        payload,
        type,
    }
}
